import { render, staticRenderFns } from "./PersonnelChartsSection.vue?vue&type=template&id=ef7d51a6&scoped=true"
import script from "./PersonnelChartsSection.vue?vue&type=script&lang=js"
export * from "./PersonnelChartsSection.vue?vue&type=script&lang=js"
import style0 from "./PersonnelChartsSection.vue?vue&type=style&index=0&id=ef7d51a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7d51a6",
  null
  
)

export default component.exports